import {
  CREATE_OWNER_SUCCESS,
  FETCH_OWNER_SUCCESS,
  GET_OWNER_SUCCESS,
  SAVE_OWNER_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_OWNER_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_OWNER_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_OWNER_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_OWNER_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }


    default:
      return state;
  }
}
